<template>
<div class="modal micromodal-slide" :id="id" aria-hidden="true">
  <div class="modal__overlay" tabindex="-1" data-micromodal-close>
    <div class="modal__container" role="dialog" aria-modal="true" :aria-labelledby="id + '-title'">
      <header class="modal__header">
        <!-- <h2 class="modal__title" :id="id + '-title'">
          <slot name=""></slot>
        </h2> -->
        <button class="modal__close" aria-label="Close modal" data-micromodal-close></button>
      </header>
      <main class="modal__content" :id="id + '-content'">
        <slot></slot>
      </main>
      <!-- <footer class="modal__footer">
        <button class="modal__btn modal__btn-primary">Continue</button>
        <button class="modal__btn" data-micromodal-close aria-label="Close this dialog window">Close</button>
      </footer> -->
    </div>
  </div>
</div> 
</template>

<script>
export default {
  name: 'modal',

  props: {
    id: {
      type: String,
      default: `modal-${this._uid}`
    }
  },

  mounted() {
    if (window.MicroModal) {
      MicroModal.init()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/js/components/modal.vue